import React from "react"

import BasePermissionGate, { BasePermissionGateProps } from "@/components/PermissionGate/BasePermissionGate"

const AttendantGroupPermissionGate = (props: Omit<BasePermissionGateProps<"attendant">, "feature">) => {
	return (
		<BasePermissionGate
			{...props}
			feature="attendant"
		/>
	)
}

export default AttendantGroupPermissionGate
